module.exports = __webpack_public_path__ + "img/IT0000639755447.f68bf1a5.png";